import React from 'react';
import PropTypes from 'prop-types';
import UserCardAvatar from '../UserCardAvatar';

import './index.scss';

export const ChatMessageNotification = ({ senderId, senderName, messagePreview }) => (
    <div className="chat-message-notification" data-testid="chat-message-notification">
        <UserCardAvatar
            userId={senderId}
            username={senderName}
            className="chat-message-notification__avatar"
            avatarClassName="chat-message-notification__avatar-media"
            radius="50%"
        />
        <div className="chat-message-notification__content">
            <span className="chat-message-notification__sender" title={senderName}>
                {senderName || 'New message'}
            </span>
            <span className="chat-message-notification__preview" title={messagePreview}>
                {messagePreview}
            </span>
        </div>
    </div>
);

ChatMessageNotification.propTypes = {
    senderId: PropTypes.string.isRequired,
    senderName: PropTypes.string,
    messagePreview: PropTypes.string,
};

ChatMessageNotification.defaultProps = {
    senderName: 'New message',
    messagePreview: '',
};

export default ChatMessageNotification;
